export const colors = {
  //grey
  brown_grey: "#aaaaaa",
  slate_grey: "#58595b",
  bg_grey: "#f6f6f6",
  greyish_brown: "#555555",
  greyish_brown_two: "#595959",
  very_light_pink: "#cfcfcf",
  very_very_light_two: "#cccccc",
  very_light_pink_three: "#d8d8d8",
  very_light_pink_four: "#f2f2f2",
  very_light_pink_five: "#e8e8e8",
  very_light_pink_six: "#ececec",

  //black
  black: "#000000",
  light_black: "#222222",

  //white
  white: "#ffffff",
  grey_white: "#f7f7f7",
  white_two: "#f6f6f6",

  //red
  red: "#ff0000",
  bright_red: "#ff0012",
  light_red: "#ffe8e8",

  //orange
  blood_orange: "#fb5004",
  ligh_blood_orange: "#fe4f00",
  dark_orange: "#ff3b00"
}
